import React from 'react';
import TitleText from '../../../../Components/TitleText/TitleText';
import './OurTeam.css';
import Button from '../../../../Components/Button/Button';
import { Link } from 'react-router-dom';


const OurTeam = (props) => {

    return (
        <div id="team">
            <div className='container' >
                <div className="row " data-aos="fade-in" data-aos-duration="3000">
                    <TitleText title1="Our" title2="Team" position="center" />
                    <div className='teams container'>

                        <>
                            <div className="row">

                                {
                                    props.team.sort((a, b) => a.serial - b.serial).slice(0, 3).map(team =>
                                        <div key={team.name} className='col-lg-4 col-md-6 teamCard'>
                                            <div className="inner">
                                                <img className='teamCardImg' src={team.img} alt="" width="100%" />
                                            </div>
                                            <div className='teamCardTitleContainer' >
                                                <h5 className='teamCardName'>{team.name}</h5>
                                                <p className='teamCardDesignation'>{team.designation}</p>
                                                {
                                                    team.study ? <p className='teamCardStudy'>{team.study} <br />
                                                    </p> : <></>
                                                }
                                                {
                                                    team.membership ? <span className='teamCardStudy'>{team.membership}</span> : <></>
                                                }
                                            </div>
                                        </div>)
                                }
                            </div>
                        </>

                    </div>
                    <center className='mt-5'>
                        <Link to="/teamView">
                            <Button title="Watch More" />
                        </Link>
                    </center>
                </div>

            </div>
        </div>
    );
};
export default OurTeam;